export function visualSpaces(input: string | undefined): string | undefined {
  if (input === undefined) {
    return undefined;
  }

  return input.replaceAll(" ", "␠").replaceAll("\t", "␉");
}
